/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ApplicationCodePromise {
        
        public model: GetCodeModel;
        public includeInactiveCodes: boolean;
        public deferred: ng.IDeferred<models.ApplicationCode[]>;

        constructor(model: GetCodeModel, includeInactiveCodes: boolean, deferred: ng.IDeferred<models.ApplicationCode[]>) {
            this.model = model;
            this.includeInactiveCodes = includeInactiveCodes;
            this.deferred = deferred;
        }

        
    }
}